import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { Observer } from 'rxjs/Observer'
import 'rxjs/add/observable/of'
import ActionCable from 'actioncable'
import { wsHost } from '../config'

@Injectable()
export class ActioncableApi {
  private cable: ActionCable.Cable = null
  private channels: { [key: string]: ActionCable.Channel } = {}

  constructor() {
    this.cable = ActionCable.createConsumer(wsHost())
  }

  subscribeChannel(channel: string, params: any): Observable<{}> {
    params.channel = channel

    return new Observable((observer: Observer<{}>) => {
        this.channels[channel] = this.cable.subscriptions.create(
          params, {
            connected: () => { },
            disconnected: () => observer.error({}),
            received: (msg) => observer.next(msg),
          })
      })
  }

  perform(channel: string, action: string, data: Object) {
    this.channels[channel].perform(action, data)
  }
}



// WEBPACK FOOTER //
// ./src/apis/actioncable.ts